import {sum} from "../js/util/UtilFunctions";

/** @ngInject */
export default function riskController($scope, $uibModal, $state, $resource, gridUtil, uiGridConstants, uiGridExporterConstants, uiGridGroupingConstants, $localStorage, $timeout, $http, csv, $sanitize, terms, $aside, userConfig) {

    var currencyFormat = d3.format("$,.0f");

    var portfolios = [];
    var defaultStorage = {};

    defaultStorage.worstCase = false;
    defaultStorage.clientMargin = true;

    defaultStorage.exposure = {
        chartType: "delta",
        zoomLevel: "few"
    };

    defaultStorage.levelPresets = {};

    defaultStorage.riskTour = {
        complete: false,
        skipped: false
    };

    $scope.$storage = $localStorage.$default(defaultStorage);

    $scope.asAt = null;

    $scope.selectedPriceLevel = null;

    $scope.adviserFilter = null;
    $scope.advisers = [];

    $scope.selectAdviserFilter = function (adviser) {
        $scope.adviserFilter = adviser;
        loadChartData();
    };

    $scope.emailConfigExport = function (size) {

        var modalInstance = $uibModal.open({

            templateUrl: "app/risk/templates/emailConfig/emailConfig.tpl.html",
            windowClass: "margin-top25",
            controller: "riskReportCtrl as riskReportCtrl",
            resolve: {
                userScenarioDefinitions: function () {
                    return $http.get("/tradefloor/api/rm/report/scenarios")
                }
//                        userConfig : function () {
//                            return userConfig;
//                        }
            },
            size: size


        });
    };

    $scope.onFinishTour = function (completed) {
        $scope.$storage.riskTour.complete = true;
        $scope.$storage.riskTour.skipped = !completed;
    };

    $scope.startJoyRide = false;

    $state.current.data.startTour = function () {
        $scope.startJoyRide = true;
    };


    $scope.ngJoyrideConfig = [

        {
            type: "title",
            heading: "Risk Manager Screen",
            text:
                "<span>Welcome to the Risk Manager screen. This screen aims to make it simple to understand" +
                " how exposure is spread for your book of clients.  </span>"

        },
        {
            type: "element",
            selector: "#stressTestOverview",
            text: "This is a handy overview that allows you to see a total of all the negative Net Liquidation Values and " +
                "Shortfalls per each account over a set of scenarios that you create. This means that you can see the worst case " +
                "scenario in the event of a severe market movement, and know the <b> net loss </b>to the <b>broker </b>",
            placement: "right",
            scroll: true,
            attachToBody: true

        },
        {
            type: "element",
            selector: "#NLVchart",
            text: "...and this chart will give you a graphical representation of these scenarios",
            placement: "left",
            scroll: true,
            attachToBody: true

        },
        {
            type: "element",
            selector: "#stressTestDetailed",
            text: "A detailed view of these scenarios per account can be viewed here. Each client will have a single" +
                " entry per each selected scenario, showing the stressed collateral, margin, cash, net liquidation value and " +
                "shortfall.",
            placement: "top",
            scroll: true,
            attachToBody: true

        },
        //{
        //    type: "element",
        //    selector: ".ui-grid-menu-button",
        //    text: "Like most screens in the application, you can customise your view based on what is of interest. " +
        //        "Clicking on the bars will allow you to choose columns that interest you. As the application is responsive, " +
        //        "these settings will be saved per device.",
        //    placement: "left",
        //    scroll: true,
        //    attachToBody: true
        //}  ,
        //{
        //    type: "element",
        //    selector: "#exportDataARisk",
        //    text: "You can export data to CSV, by clicking this button. You can choose to export all data, or just what " +
        //        "is visible based on your filters.",
        //    placement: "left",
        //    scroll: true,
        //    attachToBody: true
        //
        //} ,
        {
            type: "element",
            selector: "#worstCaseFilter",
            text: "By switching this setting on, only the worst case scenarios will come up for each individual client.",
            placement: "left",
            scroll: true,
            attachToBody: true

        },
        {
            type: "element",
            selector: "#dollarDeltaExposure",
            text: "This widget allows you to see distribution of margin & exposure per security, per account.",
            placement: "top",
            scroll: true,
            attachToBody: true

        },
        {
            type: "element",
            selector: "#dollarDeltaDeltaView",
            text: "..thus, selecting dollar delta will show you the largest net longs and net shorts per each account per each security.",
            placement: "bottom",
            scroll: true,
            attachToBody: true

        },
        {
            type: "element",
            selector: "#dollarDeltaASXView",
            text: "You can do the same for ASX Margin, which excludes any inter-commodity concessions to avoid distorting data.",
            placement: "bottom",
            scroll: true,
            attachToBody: true

        },
        {
            type: "element",
            selector: "#dollarDeltaScanRiskView",
            text: "..or just view it for scan risk alone (i.e. excluding premium margin from the equation).",
            placement: "bottom",
            scroll: true,
            attachToBody: true

        },

        {
            type: "element",
            selector: "#dollarDeltaPremiumView",
            text: "..or vice versa, by looking only at the distribution of premium margin per security per account.",
            placement: "bottom",
            scroll: true,
            attachToBody: true

        },
        {
            type: "element",
            selector: "#viewAll",
            text: "You can see all the data available.",
            placement: "left",
            scroll: true,
            attachToBody: true

        },
        {
            type: "element",
            selector: "#viewFew",
            text: "...or just the largest.",
            placement: "left",
            scroll: true,
            attachToBody: true

        },
        {
            type: "element",
            selector: "#stressScenariosDollarExposure",
            text: "...and best of all - you can apply stress tests right over the top, to see how your chosen parameter will change in the event of " +
                "extreme market conditions.",
            placement: "bottom",
            scroll: true,
            attachToBody: true

        }
    ];

    $scope.pointInTime = "current";

    $scope.showStressTest = function () {
        $scope.isshowStressTest = !$scope.isshowStressTest;
    };

    $scope.showTimeMod = function () {
        $scope.isshowTimeMod = !$scope.isshowTimeMod;
    };

    $scope.selectedScenario = null;


    $scope.selectLevel = function (level, filterTable) {
        $scope.selectedPriceLevel = level;
        $scope.selectScenario(level.activeOutcome.scenario);

        if (filterTable) {
            $scope.gridApi.grid.getColumn("scenario").filters[0].term = level.name;
        }

    };

    $scope.selectScenario = function (scenario) {
        if ($scope.selectedScenario != scenario) {
            $scope.selectedScenario = scenario;
            loadRiskSummary(scenario);
        }
    };

    $scope.setPointInTime = function (pointInTime) {
        $scope.pointInTime = pointInTime;
        $scope.refresh();
    };

    $scope.brokerOutcomes = [];

    $scope.brokerOutcomesChartOptions = {
        chart: {
            type: "multiBarChart",
            height: 280,
            margin: {
                top: 10,
                right: 10,
                bottom: 20,
                left: 60
            },
            x: function (d) {
                return d[0];
            },
            y: function (d) {
                return d[1];
            },
            clipEdge: true,
            staggerLabels: false,
            showControls: false,
            showValues: true,
            duration: 1000,
            stacked: false,
            xAxis: {
                showMaxMin: false,
                highlightZero: false
            },
            yAxis: {

                axisLabel: "Values",
                tickFormat: d3.format("$.3s"),
                highlightZero: false

            }

        }
    };


    $scope.brokerOutcomesChartData = [
        {
            key: "Shortfall",
            color: "red",
            values: []
        },
        {
            key: "NLV",
            color: "red",
            values: []
        }
    ];
    //

    $scope.brokerExposureChartOptions = {
        chart: {
            type: "multiBarChart",
            height: 525,
            margin: {
                top: 10,
                right: 10,
                bottom: 30,
                left: 60
            },
            x: function (d) {
                return d.x;
            },
            y: function (d) {
                switch ($scope.$storage.exposure.chartType) {
                    case "delta":
                        return d.value ? d.value.delta : 0;
                    case "premium":
                        return d.value ? d.value.premiumMargin : 0;
                    case "scan":
                        return d.value ? d.value.scanMargin : 0;
                    case "asx":
                        return d.value ? d.value.asxMargin : 0;
                }
            },
            clipEdge: true,
            staggerLabels: false,
            showControls: false,
            showValues: true,
            duration: 1000,
            stacked: true,
            xAxis: {
                tickFormat: function (e) {
                    return $scope.data[0].values[e].cc;
                },
                showMaxMin: false,
                highlightZero: false
            },
            yAxis: {

                axisLabel: "Values",
                tickFormat: d3.format("$.3s"),
                highlightZero: false

            },
            multibar: {
                dispatch: {
                    elementClick: function (e) {
                        $state.go("portfolio", {portfolioId: e.data.value.portfolioId});
                    }
                }
            },
            tooltip: {
                contentGenerator: function (e) {
                    if (!e.data.value) {
                        return;
                    }
                    var tooltip = "<h3>" + htmlEscape(e.data.value.accountNumber) + "</h3>" +
                        "<table><tbody>" +
                        "<tr><td class=\"key\">Account</td><td class=\"value\">" + e.data.value.accountName + "</td></tr>" +
                        "<tr><td class=\"key\">Security</td><td class=\"value\">" + e.data.cc + "</td></tr>";

                    if (e.data.value.adviser) {
                        tooltip += "<tr><td class=\"key\">Adviser</td><td class=\"value\">" + e.data.value.adviser.name + " (" + e.data.value.adviser.key + ")" + "</td></tr>";
                    }

                    if (e.data.value.branch) {
                        tooltip += "<tr><td class=\"key\">Branch</td><td class=\"value\">" + e.data.value.branch.name + " (" + e.data.value.branch.key + ")" + "</td></tr>";
                    }

                    if (e.data.value.org) {
                        tooltip += "<tr><td class=\"key\">Organisation</td><td class=\"value\">" + e.data.value.org.key + "</td></tr>";
                    }

                    switch ($scope.$storage.exposure.chartType) {
                        case "delta":
                            tooltip += "<tr><td class=\"key\">Dollar Delta</td><td class=\"value\">" + currencyFormat(e.data.value.delta) + "</td></tr>";
                            break;
                        case "premium":
                            tooltip += "<tr><td class=\"key\">Premium Margin</td><td class=\"value\">" + currencyFormat(e.data.value.premiumMargin) + "</td></tr>";
                            break;
                        case "scan":
                            tooltip += "<tr><td class=\"key\">Scan Risk</td><td class=\"value\">" + currencyFormat(e.data.value.premiumMargin) + "</td></tr>";
                            break;
                        case "asx":
                            tooltip += "<tr><td class=\"key\">ASX Margin</td><td class=\"value\">" + currencyFormat(e.data.value.asxMargin) + "</td></tr>";
                            break;
                    }


                    tooltip += "</tbody></table>";

                    return tooltip;
                }
            }
        }
    };


    function htmlEscape(value) {
        return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&#39;").replace(/"/g, "&quot;");

    }

    $scope.openArchive = function () {
    };

    var allCommodities = [];

    $scope.exposureZoom = function (level) {
        $scope.$storage.exposure.zoomLevel = level;
        loadChartData();
    };

    $scope.exposureChart = function (type) {
        $scope.$storage.exposure.chartType = type;
        loadChartData();
    };


    $scope.selectWorstBrokerOutcome = function (level) {
        level.activeOutcome = level.worst;
        level.worstSelected = true;
        delete $scope.$storage.levelPresets[level.price];
        applyFilters();
    };

    $scope.selectBrokerOutcome = function (level, outcome) {
        level.activeOutcome = outcome;
        level.worstSelected = false;
        $scope.$storage.levelPresets[level.price] = outcome.id;
        applyFilters();
    };

    function loadRiskSummary(scenario) {

        $http.get("/tradefloor/api/risk/" + userConfig.backOffice + "/summary/" + scenario.id + "?current=" + ($scope.pointInTime === "current" ? "true" : "false")).then(onRiskSummaryLoaded);

        function onRiskSummaryLoaded(response) {
            var d = response.data;

            var advisers = d.advisers;
            var branches = d.branches;
            var orgs = d.orgs || [];

            function byName(a, b) {
                if (a.name < b.name) {
                    return -1;
                }

                if (a.name > b.name) {
                    return 1;
                }

                return 0;
            }

            advisers.sort(byName);

            branches.sort(byName);

            orgs.sort(byName);

            var adviserMap = {};
            var usedAdviserMap = {};
            var branchMap = {};
            var orgMap = {};

            advisers.forEach(function (g) {
                adviserMap[g.id] = g;
            });

            branches.forEach(function (g) {
                branchMap[g.id] = g;
            });

            orgs.forEach(function (g) {
                orgMap[g.id] = g;
            });

            var portfolios = d.portfolios;

            allCommodities = [];
            for (var i = 0; i < portfolios.length; i++) {
                var portfolioSummaries = portfolios[i];

                var underlyings = Object.keys(portfolioSummaries.commodities);
                for (var j = 0; j < underlyings.length; j++) {
                    var underlying = underlyings[j];
                    var commodity = portfolioSummaries.commodities[underlying];

                    var org = orgMap[portfolioSummaries.orgId];
                    var branch = branchMap[portfolioSummaries.branchId];
                    var adviser = adviserMap[portfolioSummaries.adviserId];


                    usedAdviserMap[adviser.id] = adviser;

                    allCommodities.push({
                        accountName: portfolioSummaries.accountName,
                        accountNumber: portfolioSummaries.accountNumber,
                        adviser: adviser,
                        branch: branch,
                        org: org,
                        portfolioId: portfolioSummaries.portfolioId,
                        underlying: underlying,
                        delta: commodity.delta,
                        premiumMargin: commodity.premiumMargin,
                        scanMargin: commodity.scanMargin,
                        asxMargin: commodity.asxMargin
                    });
                }
            }

            $scope.advisers = [];
            Object.keys(usedAdviserMap).forEach(function (a) {
                $scope.advisers.push(usedAdviserMap[a]);
            });
            $scope.advisers.sort(byName);

            loadChartData();

        }
    }

    function byDelta(a, b) {
        if (Math.abs(a.delta) > Math.abs(b.delta)) {
            return -1;
        }

        if (Math.abs(a.delta) < Math.abs(b.delta)) {
            return 1;
        }

        return 0;
    }

    function byScan(a, b) {
        if (Math.abs(a.scanMargin) > Math.abs(b.scanMargin)) {
            return -1;
        }

        if (Math.abs(a.scanMargin) < Math.abs(b.scanMargin)) {
            return 1;
        }

        return 0;
    }

    function byPremium(a, b) {
        if (Math.abs(a.premiumMargin) > Math.abs(b.premiumMargin)) {
            return -1;
        }

        if (Math.abs(a.premiumMargin) < Math.abs(b.premiumMargin)) {
            return 1;
        }

        return 0;
    }

    function byASX(a, b) {
        if (Math.abs(a.asxMargin) > Math.abs(b.asxMargin)) {
            return -1;
        }

        if (Math.abs(a.asxMargin) < Math.abs(b.asxMargin)) {
            return 1;
        }

        return 0;
    }


    function loadChartData() {

        var sort;
        var positiveSeriesName;
        var negativeSeriesName;


        switch ($scope.$storage.exposure.chartType) {
            case "delta":
                sort = byDelta;
                positiveSeriesName = "Positive Delta";
                negativeSeriesName = "Negative Delta";
                break;
            case "premium":
                sort = byPremium;
                positiveSeriesName = "Premium Margin";
                negativeSeriesName = "Premium Margin";
                break;
            case "scan":
                sort = byScan;
                positiveSeriesName = "Scan Margin";
                negativeSeriesName = "Scan Margin";
                break;
            case "asx":
                sort = byASX;
                positiveSeriesName = "ASX Margin";
                negativeSeriesName = "ASX Margin";
                break;
        }

        var cones = {};

        var filteredCommodities = allCommodities;

        if ($scope.adviserFilter) {
            filteredCommodities = allCommodities.filter(function (c) {
                return c.adviser == $scope.adviserFilter;
            });
        }

        filteredCommodities.sort(sort);

        switch ($scope.$storage.exposure.zoomLevel) {
            case "all":
                filteredCommodities = filteredCommodities.slice(0, Math.min(800, filteredCommodities.length));
                break;
            case "some":
                filteredCommodities = filteredCommodities.slice(0, Math.min(400, filteredCommodities.length / 2));
                break;
            case "few":
                filteredCommodities = filteredCommodities.slice(0, Math.min(200, filteredCommodities.length / 3));
                break;

        }

        for (var i = 0; i < filteredCommodities.length; i++) {
            var commodity = filteredCommodities[i];
            var cone = cones[commodity.underlying];
            if (!cone) {
                cone = {
                    underlying: commodity.underlying,
                    positive: [],
                    negative: []
                };
                cones[commodity.underlying] = cone;
            }


            switch ($scope.$storage.exposure.chartType) {
                case "delta":
                    if (commodity.delta >= 0) {
                        cone.positive.push(commodity);
                    } else {
                        cone.negative.push(commodity);
                    }

                    break;
                case "premium":
                    if (commodity.premiumMargin >= 0) {
                        cone.positive.push(commodity);
                    } else {
                        cone.negative.push(commodity);
                    }

                    sort = byPremium;
                    break;
                case "scan":

                    if (commodity.scanMargin >= 0) {
                        cone.positive.push(commodity);
                    } else {
                        cone.negative.push(commodity);
                    }
                    sort = byScan;
                    break;
                case "asx":

                    if (commodity.asxMargin >= 0) {
                        cone.positive.push(commodity);
                    } else {
                        cone.negative.push(commodity);
                    }
                    sort = byScan;
                    break;
            }

        }


        var positiveSeries = {
            key: positiveSeriesName,
            color: "green",
            values: []
        };
        var negativeSeries = {
            key: negativeSeriesName,
            color: "red",
            values: []
        };

        var underlyings = Object.keys(cones).sort();
        var x = 0;

        for (var i = 0; i < underlyings.length; i++) {
            var underlying = underlyings[i];
            var cone = cones[underlying];

            var steps = Math.max(cone.positive.length, cone.negative.length);
            for (var j = 0; j < steps; j++) {
                var pos = cone.positive[j];
                var neg = cone.negative[j];

                positiveSeries.values.push({x: x, value: pos, cc: underlying});
                negativeSeries.values.push({x: x, value: neg, cc: underlying});

                x++;
            }
        }

        $scope.data.length = 0;
        if ($scope.$storage.exposure.chartType == "asx" || $scope.$storage.exposure.chartType == "scan") {
            $scope.data.push(positiveSeries);
        } else {
            $scope.data.push(negativeSeries);
            $scope.data.push(positiveSeries);
        }

        $scope.brokerExposureChartApi.update();
    }

    $scope.data = [{
        key: "Positive Delta",
        color: "green",
        values: []
    },
        {
            key: "Negative Delta",
            color: "red",
            values: []
        }
    ];

    $scope.tags = [];

    function saveTablePreferences() {
        $timeout(function () {
            $scope.$storage.riskTable = {
                version: 1,
                data: $scope.gridApi.saveState.save()
            };
            $scope.savePromise = null;
        }, 100);

    }

    // TODO hack to get visibiilty changes saving until there is a callback to trigger it
    $scope.$on("$destroy", function () {
        $state.current.data.startTour = undefined;
        saveTablePreferences();
    });

    $scope.resetColumnFilters = function () {
        $scope.gridApi.grid.resetColumnSorting();
        $scope.gridApi.grid.clearAllFilters();
    };


    $scope.resetColumnPreferences = function () {
        $scope.$storage.riskTable = {
            version: 1
        };
        $scope.gridApi.grid.resetColumnSorting();
        $scope.gridApi.grid.clearAllFilters();
        $scope.gridOptionsStress.columnDefs = createDefaultColumns();
    };


    var data = [];

    $scope.exportCsv = function () {
        $scope.gridApi.exporter.csvExport(uiGridExporterConstants.ALL, uiGridExporterConstants.ALL);
    };

    $scope.exportCsvVisible = function () {
        $scope.gridApi.exporter.csvExport(uiGridExporterConstants.VISIBLE, uiGridExporterConstants.VISIBLE);
    };


    $scope.toggleClientMargin = function () {
        $scope.$storage.clientMargin = !$scope.$storage.clientMargin;
        applyFilters();
    };

    $scope.toggleWorstCase = function () {
        $scope.$storage.worstCase = !$scope.$storage.worstCase;
        applyFilters();
    };

    function byShortfall(a, b) {
        if (a.shortfall < b.shortfall) {
            return -1;
        } else if (a.shortfall > b.shortfall) {
            return 1;
        }

        return 0;
    }

    $scope.brokerOutcomesChartData = [];

    function applyFilters() {
        $scope.gridOptionsStress.data = [];
        $scope.brokerOutcomesChartData.length = 0;

        $scope.brokerOutcomesChartData[0] =
            {
                key: "Shortfall",
                color: "#CC0000",
                values: $scope.priceLevels.map(function (level) {
                    return ["" + level.price + "%", ($scope.$storage.clientMargin ? level.activeOutcome.clientShortfall : level.activeOutcome.shortfall)];
                })
            };
        $scope.brokerOutcomesChartData[1] =
            {
                key: "NLV",
                color: "#5F3B3B",
                values: $scope.priceLevels.map(function (level) {
                    return ["" + level.price + "%", level.activeOutcome.nlv];
                })
            };

        portfolios.forEach(function (portfolio) {

                var activeOutcomes = portfolio.scenarioResults.filter(function (result) {
                    return result.outcome.level.activeOutcome === result.outcome;
                });

                if ($scope.$storage.worstCase) {
                    var worstOutcome = null;
                    activeOutcomes.forEach(function (outcome) {
                        if (!worstOutcome || outcome.shortfall < worstOutcome.shortfall) {
                            worstOutcome = outcome;
                        }
                    });
                    activeOutcomes = [worstOutcome];
                }

                activeOutcomes.forEach(function (outcome) {
                    var mappedData = {
                        portfolioId: portfolio.id,
                        accountName: portfolio.accountName,
                        accountNumber: portfolio.accountNumber,
                        adviser: portfolio.adviser,
                        branch: portfolio.branch,
                        org: portfolio.org,
                        scenario: outcome.outcome.fullName,
                        spanMargin: portfolio.spanMargin,
                        stressedSpanMargin: outcome.spanMargin,
                        spanChange: outcome.spanChange,
                        premiumMargin: portfolio.premiumMargin,
                        stressedPremiumMargin: outcome.premiumMargin,
                        premiumChange: outcome.premiumChange,
                        cash: portfolio.cash,
                        collateral: portfolio.collateral,
                        stressedCollateral: outcome.collateral,
                        stressedEquityValue: outcome.equityValue,
                        stressedUnlodgedCollateral: outcome.unlodgedCollateral,
                        totalCash: portfolio.totalCash,
                        cm: portfolio.cm,
                        shortfall: outcome.shortfall,
                        clientShortfall: outcome.clientShortfall,
                        nlv: outcome.nlv,
                        stel: outcome.nlv - portfolio.cm,
                        totalMargin: portfolio.totalMargin,
                        clientMargin: portfolio.clientMargin,
                        additionalMargin: outcome.clientMargin - outcome.totalMargin,
                        stressedTotalMargin: outcome.totalMargin,
                        stressedClientMargin: outcome.clientMargin,
                        totalMarginChange: outcome.totalMarginChange,
                        clientMarginChange: outcome.clientMarginChange,
                        etoLedger: outcome.etoLedger,
                        equityLedger: outcome.equityLedger
                    };

                    $scope.gridOptionsStress.data.push(mappedData);
                });

            }
        );

        $scope.gridOptionsStress.data.sort(byShortfall);

        $scope.brokerOutcomesChartApi.update();
    }

    function sumNegative(value, column) {

        return value.map((v) => column.grid.getCellValue(v, column))
                    .filter((v) => v < 0)
                    .reduce(sum, 0);
    }

    function treeNegativeValueOnly(aggregate, fieldValue, numValue, row) {
        if (!aggregate.value) {
            aggregate.value = 0;
        }

        if (numValue) {
            if (numValue < 0) {
                aggregate.value += numValue;
            }
        }
    }

    function treeSum(aggregate, fieldValue, numValue, row) {
        if (!aggregate.value) {
            aggregate.value = 0;
        }

        if (numValue) {
            aggregate.value += numValue;
        }
    }

    function createDefaultColumns() {
        return [
            {
                name: "accountNumber",
                type: "string",
                displayName: "Account Number", width: "**",
                cellTemplate: "<div class=\"ui-grid-cell-contents\" ng-if=\"row.groupHeader\">{{COL_FIELD CUSTOM_FILTERS}}</div><div ng-if=\"!row.groupHeader\" class=\"ngCellText ui-grid-cell-contents colt{{$index}}\"><a ui-sref=\"portfolio({portfolioId : row.entity.portfolioId})\">{{ row.entity['accountNumber'] }}</a></div>",
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.accNum,
                cellTooltip: true,
                filter: {
                    condition: uiGridConstants.filter.CONTAINS
                },
                groupingShowAggregationMenu: false
            },
            {
                name: "accountName",
                type: "string",
                displayName: "Account Name",
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.accName,
                cellTooltip: true,
                width: "***",
                cellTemplate: "<div class=\"ui-grid-cell-contents\" ng-if=\"row.groupHeader\">{{COL_FIELD CUSTOM_FILTERS}}</div><div ng-if=\"!row.groupHeader\" class=\"ngCellText ui-grid-cell-contents colt{{$index}}\"><a ui-sref=\"portfolio({portfolioId : row.entity.portfolioId})\">{{ row.entity['accountName'] }}</a></div>",
                filter: {
                    condition: uiGridConstants.filter.CONTAINS
                },
                groupingShowAggregationMenu: false
            },
            {
                name: "adviser",
                field: "adviser.key",
                type: "string",
                headerCellTemplate: "tf/uiGridHeaderCell",
                term: terms.adviser, cellTooltip: true,
                displayName: "Adviser",
                width: "*",
                groupingShowAggregationMenu: false
            },
            {
                name: "adviserName",
                field: "adviser.name",
                type: "string",
                visible: false, cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell",
                term: terms.adviserName,
                displayName: "Adviser Name",
                width: "*",
                groupingShowAggregationMenu: false
            },
            {
                name: "org",
                field: "org.key",
                type: "string",
                visible: false,
                headerCellTemplate: "tf/uiGridHeaderCell",
                cellTooltip: true,
                displayName: "Organisation",
                width: "*",
                groupingShowAggregationMenu: false
            },
            {
                name: "branch",
                field: "branch.key",
                type: "string",
                headerCellTemplate: "tf/uiGridHeaderCell",
                term: terms.branch, cellTooltip: true,
                displayName: "Branch Code",
                width: "*",
                groupingShowAggregationMenu: false
            },
            {
                name: "branchName",
                field: "branch.name",
                type: "string",
                visible: false, cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell",
                term: terms.branchName,
                displayName: "Branch Name",
                width: "*",
                groupingShowAggregationMenu: false
            },
            {
                name: "scenario",
                type: "string", cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell", term: terms.scenario,
                cellTemplate: "<div class=\"ui-grid-cell-contents\" ng-if=\"row.groupHeader\">{{COL_FIELD CUSTOM_FILTERS}}</div><div ng-if=\"!row.groupHeader\" uib-tooltip=\"{{ row.entity.scenario }}\" class=\"ngCellText ui-grid-cell-contents colt{{$index}}\">{{ row.entity.scenario }}</div>",
                displayName: "Scenario", width: "**",
                filter: {condition: uiGridConstants.filter.CONTAINS},
                groupingShowAggregationMenu: false
            },
            {
                name: "collateral",
                type: "number",
                cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell",
                enableGrouping: false,
                term: terms.collateral,
                displayName: "Collateral",
                visible: false,
                width: "**",
                headerCellClass: "gridNumber",
                cellClass: "gridNumber",
                cellFilter: "number:0",
                filter: {condition: uiGridConstants.filter.LESS_THAN}
            },
            {
                name: "stressedCollateral",
                type: "number",
                cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell",
                enableGrouping: false,
                term: terms.stressedCollateral,
                displayName: "Stressed Collateral",
                visible: false,
                width: "**",
                headerCellClass: "gridNumber",
                cellClass: "gridNumber",
                cellFilter: "number:0",
                filter: {condition: uiGridConstants.filter.LESS_THAN}
            },
            {
                name: "stressedEquityValue",
                type: "number",
                cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell",
                enableGrouping: false,
                displayName: "Stressed Equity Value",
                visible: false,
                width: "**",
                headerCellClass: "gridNumber",
                cellClass: "gridNumber",
                cellFilter: "number:0",
                filter: {condition: uiGridConstants.filter.LESS_THAN}
            },
            {
                name: "stressedUnlodgedCollateral",
                type: "number",
                cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell",
                enableGrouping: false,
                displayName: "Stressed Un-Lodged Collateral",
                visible: false,
                width: "**",
                headerCellClass: "gridNumber",
                cellClass: "gridNumber",
                cellFilter: "number:0",
                filter: {condition: uiGridConstants.filter.LESS_THAN}
            },
            {
                name: "cash",
                type: "number",
                cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell",
                enableGrouping: false,
                term: terms.ledger,
                displayName: "Ledger",
                visible: false,
                width: "**",
                headerCellClass: "gridNumber",
                cellClass: "gridNumber",
                cellFilter: "number:0",
                filter: {condition: uiGridConstants.filter.LESS_THAN}
            },
            {
                name: "cm",
                type: "number",
                cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell",
                enableGrouping: false,
                term: terms.CMA,
                displayName: "CMA",
                visible: false,
                width: "**",
                headerCellClass: "gridNumber",
                cellClass: "gridNumber",
                cellFilter: "number:0",
                filter: {condition: uiGridConstants.filter.LESS_THAN}
            },
            {
                name: "totalCash",
                type: "number",
                cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell",
                enableGrouping: false,
                term: terms.totalCash,
                visible: false,
                displayName: "Total Cash",
                width: "**",
                headerCellClass: "gridNumber",
                cellClass: "gridNumber",
                footerCellClass: "gridNumber",
                footerCellFilter: "ledger",
                cellFilter: "number:0",
                filter: {condition: uiGridConstants.filter.LESS_THAN}
            },
            {
                name: "premiumMargin",
                type: "number",
                cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell",
                enableGrouping: false,
                term: terms.premMargin,
                displayName: "Premium Margin",
                visible: false,
                width: "**",
                headerCellClass: "gridNumber",
                footerCellClass: "gridNumber",
                footerCellFilter: "ledger",
                cellClass: "gridNumber",
                cellFilter: "number:0",
                aggregationType: uiGridConstants.aggregationTypes.sum,
                aggregationHideLabel: true,
                filter: {condition: uiGridConstants.filter.LESS_THAN},
                customTreeAggregationFn: treeSum,
                customTreeAggregationFinalizerFn: function (aggregation) {
                    aggregation.rendered = aggregation.value;
                }
            },
            {
                name: "stressedPremiumMargin",
                type: "number",
                cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell",
                enableGrouping: false,
                term: terms.stressedPremium,
                displayName: "Stressed Prem Margin",
                visible: false,
                width: "**",
                footerCellClass: "gridNumber",
                footerCellFilter: "ledger",
                headerCellClass: "gridNumber",
                cellClass: "gridNumber",
                cellFilter: "number:0",
                filter: {condition: uiGridConstants.filter.LESS_THAN},
                aggregationType: uiGridConstants.aggregationTypes.sum,
                aggregationHideLabel: true,
                customTreeAggregationFn: treeSum,
                customTreeAggregationFinalizerFn: function (aggregation) {
                    aggregation.rendered = aggregation.value;
                }
            },
            {
                name: "premiumChange",
                type: "number",
                cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell",
                enableGrouping: false,
                visible: false,
                displayName: "Premium Change",
                width: "**",
                headerCellClass: "gridNumber",
                cellClass: "gridNumber",
                footerCellClass: "gridNumber",
                footerCellFilter: "ledger",
                cellFilter: "number:0",
                filter: {condition: uiGridConstants.filter.LESS_THAN},
                aggregationType: uiGridConstants.aggregationTypes.sum,
                aggregationHideLabel: true,
                customTreeAggregationFn: treeSum,
                customTreeAggregationFinalizerFn: function (aggregation) {
                    aggregation.rendered = aggregation.value;
                }
            },
            {
                name: "spanMargin",
                type: "number",
                cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell",
                enableGrouping: false,
                term: terms.spanMargin,
                visible: false,
                displayName: "SPAN Margin",
                width: "**",
                headerCellClass: "gridNumber",
                cellClass: "gridNumber",
                footerCellClass: "gridNumber",
                footerCellFilter: "ledger",
                cellFilter: "number:0",
                filter: {condition: uiGridConstants.filter.LESS_THAN},
                aggregationType: uiGridConstants.aggregationTypes.sum,
                aggregationHideLabel: true,
                customTreeAggregationFn: treeSum,
                customTreeAggregationFinalizerFn: function (aggregation) {
                    aggregation.rendered = aggregation.value;
                }
            },
            {
                name: "stressedSpanMargin",
                type: "number",
                cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell",
                enableGrouping: false,
                term: terms.stressedSpan,
                visible: false,
                displayName: "Stressed SPAN Margin",
                width: "**",
                headerCellClass: "gridNumber",
                footerCellClass: "gridNumber",
                footerCellFilter: "ledger",
                cellClass: "gridNumber",
                cellFilter: "number:0",
                filter: {condition: uiGridConstants.filter.LESS_THAN},
                aggregationType: uiGridConstants.aggregationTypes.sum,
                aggregationHideLabel: true,
                customTreeAggregationFn: treeSum,
                customTreeAggregationFinalizerFn: function (aggregation) {
                    aggregation.rendered = aggregation.value;
                }
            },
            {
                name: "spanChange",
                type: "number",
                cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell",
                enableGrouping: false,
                term: terms.spanChange,
                visible: false,
                displayName: "SPAN Margin Change",
                width: "**",
                headerCellClass: "gridNumber",
                cellClass: "gridNumber",
                footerCellClass: "gridNumber",
                footerCellFilter: "ledger",
                cellFilter: "number:0",
                filter: {condition: uiGridConstants.filter.LESS_THAN},
                aggregationType: uiGridConstants.aggregationTypes.sum,
                aggregationHideLabel: true,
                customTreeAggregationFn: treeSum,
                customTreeAggregationFinalizerFn: function (aggregation) {
                    aggregation.rendered = aggregation.value;
                }
            },
            {
                name: "totalMargin",
                type: "number",
                cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell",
                enableGrouping: false,
                term: terms.totalMargin,
                visible: false,
                displayName: "Total Margin",
                width: "**",
                headerCellClass: "gridNumber",
                cellClass: "gridNumber",
                cellFilter: "number:0",
                footerCellClass: "gridNumber",
                aggregationType: uiGridConstants.aggregationTypes.sum,
                aggregationHideLabel: true,
                footerCellFilter: "ledger",
                filter: {condition: uiGridConstants.filter.LESS_THAN},
                customTreeAggregationFn: treeSum,
                customTreeAggregationFinalizerFn: function (aggregation) {
                    aggregation.rendered = aggregation.value;
                }
            },
            {
                name: "stressedTotalMargin",
                type: "number",
                cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell",
                enableGrouping: false,
                term: terms.stressedTotalMargin,
                visible: false,
                displayName: "Stressed Total Margin",
                width: "**",
                headerCellClass: "gridNumber",
                cellClass: "gridNumber",
                cellFilter: "number:0",
                footerCellClass: "gridNumber",
                aggregationType: uiGridConstants.aggregationTypes.sum,
                aggregationHideLabel: true,
                treeAggregationType: uiGridGroupingConstants.aggregation.SUM,
                footerCellFilter: "ledger",
                filter: {condition: uiGridConstants.filter.LESS_THAN},
                customTreeAggregationFn: treeSum,
                customTreeAggregationFinalizerFn: function (aggregation) {
                    aggregation.rendered = aggregation.value;
                }
            },
            {
                name: "totalMarginChange",
                type: "number",
                cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell",
                enableGrouping: false,
                term: terms.totalMarginChange,
                visible: false,
                displayName: "Total Margin Change",
                width: "**",
                headerCellClass: "gridNumber",
                cellClass: "gridNumber",
                cellFilter: "number:0",
                footerCellClass: "gridNumber",
                aggregationType: uiGridConstants.aggregationTypes.sum,
                aggregationHideLabel: true,
                footerCellFilter: "ledger",
                filter: {condition: uiGridConstants.filter.LESS_THAN},
                customTreeAggregationFn: treeSum,
                customTreeAggregationFinalizerFn: function (aggregation) {
                    aggregation.rendered = aggregation.value;
                }
            },
            {
                name: "clientMargin",
                type: "number",
                cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell",
                enableGrouping: false,
                visible: false,
                displayName: "Client Margin",
                width: "**",
                headerCellClass: "gridNumber",
                cellClass: "gridNumber",
                cellFilter: "number:0",
                footerCellClass: "gridNumber",
                aggregationType: uiGridConstants.aggregationTypes.sum,
                aggregationHideLabel: true,
                footerCellFilter: "ledger",
                filter: {condition: uiGridConstants.filter.LESS_THAN},
                customTreeAggregationFn: treeSum,
                customTreeAggregationFinalizerFn: function (aggregation) {
                    aggregation.rendered = aggregation.value;
                }
            },
            {
                name: "stressedClientMargin",
                type: "number",
                cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell",
                enableGrouping: false,
                visible: false,
                displayName: "Stressed Client Margin",
                width: "**",
                headerCellClass: "gridNumber",
                cellClass: "gridNumber",
                cellFilter: "number:0",
                footerCellClass: "gridNumber",
                aggregationType: uiGridConstants.aggregationTypes.sum,
                aggregationHideLabel: true,
                footerCellFilter: "ledger",
                filter: {condition: uiGridConstants.filter.LESS_THAN},
                customTreeAggregationFn: treeSum,
                customTreeAggregationFinalizerFn: function (aggregation) {
                    aggregation.rendered = aggregation.value;
                }
            },
            {
                name: "clientMarginChange",
                type: "number",
                cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell",
                enableGrouping: false,
                displayName: "Client Margin Chg",
                width: "**",
                headerCellClass: "gridNumber",
                cellClass: "gridNumber",
                cellFilter: "number:0",
                footerCellClass: "gridNumber",
                aggregationType: uiGridConstants.aggregationTypes.sum,
                aggregationHideLabel: true,
                footerCellFilter: "ledger",
                filter: {condition: uiGridConstants.filter.LESS_THAN},
                customTreeAggregationFn: treeSum,
                customTreeAggregationFinalizerFn: function (aggregation) {
                    aggregation.rendered = aggregation.value;
                }
            },
            {
                name: "additionalMargin",
                type: "number",
                cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell",
                enableGrouping: false,
                visible: false,
                term: terms.addMargin,
                displayName: "Add Margin",
                width: "**",
                headerCellClass: "gridNumber",
                cellClass: "gridNumber",
                cellFilter: "number:0",
                footerCellClass: "gridNumber",
                aggregationType: uiGridConstants.aggregationTypes.sum,
                aggregationHideLabel: true,
                footerCellFilter: "ledger",
                filter: {condition: uiGridConstants.filter.GREATER_THAN},
                customTreeAggregationFn: treeSum,
                customTreeAggregationFinalizerFn: function (aggregation) {
                    aggregation.rendered = aggregation.value;
                }
            },
            {
                name: "etoLedger",
                type: "number",
                cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell",
                enableGrouping: false,
                visible: false,
                term: terms.etoLedger,
                displayName: "ETO Ledger",
                width: "**",
                headerCellClass: "gridNumber",
                cellClass: "gridNumber",
                cellFilter: "number:0",
                footerCellClass: "gridNumber",
                aggregationType: uiGridConstants.aggregationTypes.sum,
                aggregationHideLabel: true,
                footerCellFilter: "ledger",
                filter: {condition: uiGridConstants.filter.GREATER_THAN}
            },
            {
                name: "equityLedger",
                type: "number",
                cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell",
                enableGrouping: false,
                visible: false,
                term: terms.equityLedger,
                displayName: "Equity Ledger",
                width: "**",
                headerCellClass: "gridNumber",
                cellClass: "gridNumber",
                cellFilter: "number:0",
                footerCellClass: "gridNumber",
                aggregationType: uiGridConstants.aggregationTypes.sum,
                aggregationHideLabel: true,
                footerCellFilter: "ledger",
                filter: {condition: uiGridConstants.filter.GREATER_THAN},
                customTreeAggregationFn: treeSum,
                customTreeAggregationFinalizerFn: function (aggregation) {
                    aggregation.rendered = aggregation.value;
                }
            },
            {
                name: "nlv",
                type: "number",
                cellTooltip: true,
                filter: {condition: uiGridConstants.filter.LESS_THAN},
                enableGrouping: false,
                term: terms.nlv,
                headerCellTemplate: "tf/uiGridHeaderCell",
                displayName: "NLV",
                width: "**",
                headerCellClass: "gridNumber",
                cellClass: "gridNumber",
                cellFilter: "number:0",
                footerCellClass: "gridNumber",
                customTreeAggregationFn: treeNegativeValueOnly,
                aggregationType: sumNegative,
                aggregationHideLabel: true,
                footerCellFilter: "ledger",
                cellTemplate: "<div class=\"ui-grid-cell-contents\" ng-if=\"row.groupHeader\">{{COL_FIELD CUSTOM_FILTERS}}</div><div ng-if=\"!row.groupHeader\" class=\"ngCellText ui-grid-cell-contents colt{{$index}}\" ng-class=\"{'short' : row.entity.nlv < 0}\"><span>{{row.entity.nlv | number:2 }}</span></div>",
                customTreeAggregationFinalizerFn: function (aggregation) {
                    aggregation.rendered = aggregation.value;
                }
            }].concat(
            !userConfig.support ? [] : [{
                name: "stel",
                type: "number",
                cellTooltip: false,
                headerCellTemplate: "tf/uiGridHeaderCell",
                enableGrouping: false,
                displayName: "STEL",
                width: "**",
                headerCellClass: "gridNumber",
                cellClass: "gridNumber",
                cellFilter: "number:0",
                filter: {condition: uiGridConstants.filter.LESS_THAN},
                aggregationType: uiGridConstants.aggregationTypes.sum,
                treeAggregationType: uiGridGroupingConstants.aggregation.SUM,
                cellTemplate: "<div class=\"ui-grid-cell-contents\" ng-if=\"row.groupHeader\">{{COL_FIELD CUSTOM_FILTERS}}</div><div ng-if=\"!row.groupHeader\" class=\"ngCellText ui-grid-cell-contents colt{{$index}}\"><span>{{row.entity.stel | number:2 }}</span></div>",
                footerCellClass: "gridNumber",
                aggregationHideLabel: true,
                footerCellFilter: "ledger",
                customTreeAggregationFinalizerFn: function (aggregation) {
                    aggregation.rendered = aggregation.value;
                }
            }]).concat(
            [{
                name: "shortfall",
                type: "number",
                cellTooltip: true,
                headerCellTemplate: "tf/uiGridHeaderCell",
                enableGrouping: false,
                visible: false,
                term: terms.shortfall,
                displayName: "Shortfall",
                width: "**",
                headerCellClass: "gridNumber",
                cellClass: "gridNumber",
                cellFilter: "number:0",
                filter: {condition: uiGridConstants.filter.LESS_THAN},
                cellTemplate: "<div class=\"ui-grid-cell-contents\" ng-if=\"row.groupHeader\">{{COL_FIELD CUSTOM_FILTERS}}</div><div ng-if=\"!row.groupHeader\" class=\"ngCellText ui-grid-cell-contents colt{{$index}}\" ng-class=\"{'short' : row.entity.shortfall < 0}\"><span>{{row.entity.shortfall | number:2 }}</span></div>",
                footerCellClass: "gridNumber",
                customTreeAggregationFn: treeNegativeValueOnly,
                aggregationType: sumNegative,
                aggregationHideLabel: true,
                footerCellFilter: "ledger",
                customTreeAggregationFinalizerFn: function (aggregation) {
                    aggregation.rendered = aggregation.value;
                }
            },
                {
                    name: "clientShortfall",
                    type: "number", cellTooltip: true,
                    headerCellTemplate: "tf/uiGridHeaderCell",
                    enableGrouping: false,
                    term: terms.clientShortfall,
                    displayName: "Client Shortfall",
                    width: "**",
                    headerCellClass: "gridNumber",
                    cellClass: "gridNumber",
                    cellFilter: "number:0",
                    filter: {condition: uiGridConstants.filter.LESS_THAN},
                    cellTemplate: "<div class=\"ui-grid-cell-contents\" ng-if=\"row.groupHeader\">{{COL_FIELD CUSTOM_FILTERS}}</div><div ng-if=\"!row.groupHeader\" class=\"ngCellText ui-grid-cell-contents colt{{$index}}\" ng-class=\"{'short' : row.entity.clientShortfall < 0}\"><span>{{row.entity.clientShortfall | number:2 }}</span></div>",
                    footerCellClass: "gridNumber",
                    customTreeAggregationFn: treeNegativeValueOnly,
                    aggregationType: sumNegative,
                    aggregationHideLabel: true,
                    footerCellFilter: "ledger",
                    customTreeAggregationFinalizerFn: function (aggregation) {
                        aggregation.rendered = aggregation.value;
                    }
                }
            ]);
    }

    $scope.openTablePrefs = function () {
        var position = "right";
        var backdrop = true;

        $scope.asideState = {
            open: true,
            position: position
        };

        $aside.open({
            templateUrl: "/tradefloor/app/layout/tablePrefs/openPosPref.html",
            placement: position,
            size: "sm",
            backdrop: backdrop,
            controller: "TablePrefCtrl",
            resolve: {
                gridApi: function () {
                    return $scope.gridApi;
                }
            }

        });
    };

    $scope.gridOptionsStress = {
        tableName: "Stressed Results",
        flatEntityAccess: false,
        enableGridMenu: false,
        enableColumnResizing: true,
        enableFiltering: true,
        enableGrouping: true,
        saveFilter: false,
        saveScroll: false,
        saveFocus: false,
        minRowsToShow: 15,
        enablePaging: false,
        excessRows: 20,
        showColumnFooter: true,
        enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
        exporterCsvFilename: "stress_test.csv",
        exporterMenuCsv: false,
        exporterMenuPdf: false,
        columnDefs: createDefaultColumns(),
        savePreferencesFn: saveTablePreferences,
        columnPresets: [
            {name: "Desktop", icon: "icon-desktop", minWidth: 1200, resetFn: createDefaultColumns}
        ],
        onRegisterApi: function (gridApi) {
            $scope.gridApi = gridApi;
            gridUtil.disableAnimations(gridApi.grid.element);
            $scope.gridApi.colMovable.on.columnPositionChanged($scope, saveTablePreferences);
            $scope.gridApi.core.on.sortChanged($scope, saveTablePreferences);
            $scope.gridApi.core.on.columnVisibilityChanged($scope, saveTablePreferences);
            $scope.gridApi.grouping.on.groupingChanged($scope, saveTablePreferences);
            $scope.gridApi.colResizable.on.columnSizeChanged($scope, saveTablePreferences);

            $timeout(function () {
                if ($scope.$storage.riskTable) {
                    // Reset if the data isn't versioned
                    if ($scope.$storage.riskTable.version === undefined) {
                        $scope.$storage.riskTable.version = 1;
                        return;
                    }
                    if ($scope.$storage.riskTable.data) {
                        $scope.gridApi.saveState.restore($scope, $scope.$storage.riskTable.data);
                    }
                }
            }, 0);
        },

        data: []
    };


    $scope.refresh = function () {
        $http.get("/tradefloor/api/stress/" + userConfig.backOffice + "/results/latest" + "?current=" + ($scope.pointInTime === "current" ? "true" : "false")).then(onResultsLoaded);

        function onResultsLoaded(response) {
            var data = response.data;

            var advisers = data.advisers;
            var branches = data.branches;
            var orgs = data.orgs || [];

            var adviserMap = {};
            var branchMap = {};
            var orgMap = {};

            advisers.forEach(function (a) {
                adviserMap[a.id] = a;
            });

            branches.forEach(function (b) {
                branchMap[b.id] = b;
            });

            orgs.forEach(function (o) {
                orgMap[o.id] = o;
            });

            $scope.asAt = data.pointInTime;

            var scenarioOutcomes = {};
            var priceLevels = {};
            $scope.scenarios = [];
            $scope.selectedScenario = null;

            $scope.asAt = data.asAt;
            $scope.updated = data.updated;

            for (var i = 0; i < data.scenarios.length; i++) {
                var scenario = data.scenarios[i];

                var priceLevel = priceLevels[scenario.price];
                var preset = $scope.$storage.levelPresets[scenario.price];

                if (!priceLevel) {
                    priceLevel = {
                        price: scenario.price,
                        name: "Market " + scenario.price + "%",
                        outcomes: [],
                        worst: null,
                        activeOutcome: null,
                        worstSelected: !preset
                    };

                    priceLevels[scenario.price] = priceLevel;

                }

                if (scenario.vol === 0) {
                    $scope.scenarios.push(scenario);
                    priceLevel.baseScenario = scenario;
                }

                if (scenario.vol === 0 && scenario.price === 0) {
                    $scope.defaultScenario = scenario;
                    $scope.selectedPriceLevel = priceLevel;
                }

                var shortName = scenario.vol ? ("" + scenario.vol + "%") : "Unch";
                var scenarioOutcome = {
                    id: scenario.id,
                    scenario: scenario,
                    level: priceLevel,
                    vol: scenario.vol,
                    name: shortName,
                    fullName: priceLevel.name + (scenario.vol ? ", Vol " + shortName : ""),
                    nlv: 0,
                    shortfall: 0,
                    clientShortfall: 0
                };

                scenario.outcome = scenarioOutcome;

                if (scenario.id == preset) {
                    priceLevel.activeOutcome = scenarioOutcome;
                }

                scenarioOutcomes[scenario.id] = scenarioOutcome;
                priceLevel.outcomes.push(scenarioOutcome);

                priceLevel.outcomes.sort(function (a, b) {
                    if (a.vol === undefined) {
                        return -1;
                    }

                    if (b.vol === undefined) {
                        return 1;
                    }

                    if (a.scenario.vol < b.scenario.vol) {
                        return -1;
                    }
                    if (a.scenario.vol > b.scenario.vol) {
                        return 1;
                    }

                    return 0;
                });

            }

            $scope.scenarios.sort(function (a, b) {
                if (a.price < b.price) {
                    return -1;
                }
                if (a.price > b.price) {
                    return 1;
                }

                if (a.vol < b.vol) {
                    return -1;
                }

                if (a.vol > b.vol) {
                    return 1;
                }

                return 0;
            });

            $scope.priceLevels = [];
            Object.keys(priceLevels).forEach(function (entry) {
                $scope.priceLevels.push(priceLevels[entry]);
            });

            $scope.priceLevels.sort(function (a, b) {
                if (a.price < b.price) {
                    return -1;
                }
                if (a.price > b.price) {
                    return 1;
                }

            });


            var portfoliosMap = {};

            data.portfolios.forEach(function (portfolio) {
                portfoliosMap[portfolio.id] = portfolio;
                portfolio.scenarioResults = [];
            });

            data.portfolioScenarios.forEach(function (result) {
                var portfolio = portfoliosMap[result.portfolioId];
                if (!portfolio) {
                    return;
                }

                result.premiumChange = result.premiumMargin - portfolio.premiumMargin;
                result.spanChange = result.spanMargin - portfolio.spanMargin;
                result.totalMarginChange = result.totalMargin - portfolio.totalMargin;
                result.clientMarginChange = result.clientMargin - portfolio.clientMargin;

                result.account = portfolio;

                portfolio.scenarioResults.push(result);
            });

            Object.keys(portfoliosMap).forEach(function (portfolioId) {
                var portfolio = portfoliosMap[portfolioId];

                portfolio.adviser = adviserMap[portfolio.adviserId];
                portfolio.branch = branchMap[portfolio.branchId];
                portfolio.org = orgMap[portfolio.orgId];

                portfolio.worstOutcome = null;

                portfolio.scenarioResults.forEach(function (result) {
                    if (!portfolio.worstOutcome || result.shortfall < portfolio.worstOutcome.shortfall) {
                        portfolio.worstOutcome = result;
                    }

                    var scenarioOutcome = scenarioOutcomes[result.scenarioId];

                    result.outcome = scenarioOutcome;

                    if (result.nlv < 0) {
                        scenarioOutcome.nlv += result.nlv;
                    }

                    if (result.shortfall < 0) {
                        scenarioOutcome.shortfall += result.shortfall;
                    }

                    if (result.clientShortfall < 0) {
                        scenarioOutcome.clientShortfall += result.clientShortfall;
                    }


                });

            });

            $scope.worstLevel = null;
            $scope.priceLevels.forEach(function (level) {

                level.outcomes.forEach(function (outcome) {
                    if (!level.worst || outcome.clientShortfall < level.worst.clientShortfall) {
                        level.worst = outcome;
                    }
                });


                if (!$scope.worstLevel || level.worst.clientShortfall < $scope.worstLevel.worst.clientShortfall) {
                    $scope.worstLevel = level;
                }

                if (!level.activeOutcome) {
                    level.activeOutcome = level.worst;
                }
            });

            portfolios = data.portfolios;

            applyFilters();
            $scope.selectScenario($scope.selectedPriceLevel.activeOutcome.scenario);

            $scope.lastUpdated = new Date();

        }

    };

    $scope.refresh();
}
